import React, { ReactNode } from "react";

import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import VidPauseIcon from "@atlaskit/icon/glyph/vid-pause";
import VidPlayIcon from "@atlaskit/icon/glyph/vid-play";

const iconButtonStyles = css({
    border: "0 none",
    backgroundColor: "transparent",
    padding: "0px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    height: "32px",
    width: "32px"
});

export interface ArrowButtonProps {
    "onClick": () => void;
    "icon": ReactNode;
    "aria-label": string;
}

export const ArrowButton: React.FC<ArrowButtonProps> = ({
    onClick,
    icon,
    "aria-label": ariaLabel
}) => {
    return (
        <button css={iconButtonStyles} onClick={onClick} aria-label={ariaLabel}>
            {icon}
        </button>
    );
};

export interface PlayPauseButtonProps {
    onClick: () => void;
    isRotating: boolean;
}

export const PlayPauseButton: React.FC<PlayPauseButtonProps> = ({
    onClick,
    isRotating
}) => {
    const intl = useIntl();
    return (
        <button onClick={onClick} css={iconButtonStyles}>
            {isRotating ? (
                <VidPauseIcon
                    label={intl.formatMessage({
                        id: "confluence.paid.lp.carousel.pause",
                        defaultMessage: "Pause carousel"
                    })}
                    size="small"
                />
            ) : (
                <VidPlayIcon
                    label={intl.formatMessage({
                        id: "confluence.paid.lp.carousel.play",
                        defaultMessage: "Play carousel"
                    })}
                    size="small"
                />
            )}
        </button>
    );
};
